var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerWaterUnitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#000000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000, 25.000) scale(0.025000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130-280h187.08q-22.77-17.38-41.5-40.08-18.73-22.69-31.27-49.92H130v90Zm350 0q83 0 141.5-58.5T680-480q0-83-58.5-141.5T480-680q-83 0-141.5 58.5T280-480q0 83 58.5 141.5T480-280Zm235.69-310H830v-90H642.92q22.77 17.38 41.5 40.08 18.73 22.69 31.27 49.92ZM70-184.62v-280.76h60V-430h95.69q-3.15-12.31-4.42-24.5T220-480q0-108.64 75.68-184.32Q371.36-740 480-740h350v-35.38h60v280.76h-60V-530h-95.69q3.15 12.31 4.42 24.5T740-480q0 108.64-75.68 184.32Q588.64-220 480-220H130v35.38H70ZM130-280v-90 90Zm700-310v-90 90ZM480-480Zm0 104.23q-29.15 0-49.58-20.42Q410-416.62 410-445.77q0-19.54 8.35-39.15 8.34-19.62 31.11-54.69l30.16-44.62 30.53 44.62q23.39 35.83 31.62 55.02 8.23 19.2 8.23 38.82 0 29.15-20.42 49.58-20.43 20.42-49.58 20.42Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerWaterUnitIcon);
export default __webpack_public_path__ + "static/media/marker-waterUnit-icon.914bb619681f155c0ea8624f30be3896.svg";
export { ForwardRef as ReactComponent };